import classNames from "classnames";
import { useEffect, useState } from "react";

import { ApiService, Clinic } from "pwapi";

import SelectSearchInput from "../edit/SelectSearchInput";

const mapClinicToOptionsByName = (clinics: Clinic[]) => [
  { value: "", label: "All Clinics", object: undefined },
  ...clinics
    .filter((clinic) => clinic.name)
    .map((clinic) => ({
      value: clinic.name,
      label: clinic.name,
      object: clinic,
    })),
];

const mapClinicToOptionsById = (clinics: Clinic[]) => [
  { value: "", label: "All Clinics", object: undefined },
  ...clinics
    .filter((clinic) => clinic.name)
    .map((clinic) => ({
      value: `${clinic.id}`,
      label: clinic.name,
      object: clinic,
    })),
];

const Selection = ({ object }: { object?: Clinic }) => {
  return (
    <div
      className={classNames("ClinicFilter__selection", {
        "ClinicFilter__selection--archived": object?.is_archived,
      })}
    >
      {object?.name ? (
        <>
          <span>{object.name}</span>
          {object.is_archived && (
            <code>
              <small>ARCHIVED</small>
            </code>
          )}
        </>
      ) : (
        "All Clinics"
      )}
    </div>
  );
};

const ClinicFilter = ({
  onChange,
  value,
  label = "Clinic",
}: {
  onChange: Function;
  value?: string;
  label?: string;
}) => {
  return (
    <SelectSearchInput
      label={label}
      field="clinic"
      filter="name"
      onChange={onChange}
      mapToOptions={mapClinicToOptionsByName}
      apiService={ApiService.listClinics}
      component={Selection}
    >
      <>{value || "All Clinics"}</>
    </SelectSearchInput>
  );
};

//TODO: Extend this filter to Dot, leaving that alone for the initial filtering system.
export const AdminClinicFilter = ({
  onChange,
  onInitialize,
  value,
  label = "Clinic",
  object,
}: {
  onChange: Function;
  onInitialize: Function;
  value?: string;
  label?: string;
  object?: Clinic | null;
}) => {
  const [initializing, setInitializing] = useState<boolean>(false);
  useEffect(() => {
    if ((object || value) && object?.id !== parseInt(value || "")) {
      setInitializing(true);
      ApiService.retrieveClinic({ id: object?.id || parseInt(value || "") })
        .then((response) => {
          onInitialize(response);
          setInitializing(false);
        })
        .catch(() => {
          console.error(`Error finding clinic: ${value}`);
          setInitializing(false);
        });
    }
  }, []);
  return (
    <SelectSearchInput
      label={label}
      field="clinic"
      filter="name"
      onChange={onChange}
      mapToOptions={mapClinicToOptionsById}
      apiService={ApiService.listClinics}
      component={Selection}
    >
      <>
        {initializing
          ? "..."
          : object && value && parseInt(value) === object.id
          ? object.name
          : "All Clinics"}
      </>
    </SelectSearchInput>
  );
};

export default ClinicFilter;
